__turbopack_context__.v({
  "centered": "styles-module-scss-module__JNXLAW__centered",
  "container": "styles-module-scss-module__JNXLAW__container",
  "continueButton": "styles-module-scss-module__JNXLAW__continueButton",
  "skipButton": "styles-module-scss-module__JNXLAW__skipButton",
  "sticky": "styles-module-scss-module__JNXLAW__sticky",
  "tertiaryButton": "styles-module-scss-module__JNXLAW__tertiaryButton",
  "wrap": "styles-module-scss-module__JNXLAW__wrap",
});
